<template>

  <div class="">
    <div class="container">

      <form class="form-group" id="form" v-on:submit.prevent="addRating">
        <p class="control">
          <input class="input is-medium" type="text" v-model="beerRating.name" placeholder="Vem är du?">
        </p>
        <p class="control">
          <span class="select is-medium">
            <select v-model="beerRating.beer">
              <option value="" disabled>Välj en öl i listan ...</option>
              <option v-for="(beer, index) in beers">{{ beer.name }}</option>
            </select>
          </span>
        </p>
        <div class="range-wrapper">
          <input type="range" min="0"
                 max="20" step="1"
                 v-model="sliderValue"
                 class="range-input">
          <output id="rangeInfo" class="range-output" v-text="total"></output>
        </div>
        <br>
        <p class="control">
          <input type="submit" :disabled="!isValid" class="button is-primary is-medium"  value="Sätt betyg på ölen!">
        </p>
      </form>

    </div>
  </div>

</template>

<script>

let Vue = require('vue')
let VueFire = require('vuefire')
let Firebase = require('firebase')

// explicit installation is required in a module environment
Vue.use(VueFire)

// Initialize Firebase
let config = {
  apiKey: 'AIzaSyCFXAzszhasx4hrTsWIwg9enQlsJjIyXfY',
  authDomain: 'ol3-e6f7e.firebaseapp.com',
  databaseURL: 'https://ol3-e6f7e.firebaseio.com',
  storageBucket: 'ol3-e6f7e.appspot.com',
  messagingSenderId: '899708211125'
}
Firebase.initializeApp(config)

let db = Firebase.database()
let ratingsRef = db.ref('ratings')
let beersRef = db.ref('beers')

export default {
  name: 'rating',
  data () {
    return {
      beerRating: {
        name: '',
        beer: '',
        rating: 0
      },
      newBeer: {
        name: ''
      },
      sliderValue: 0
    }
  },
  firebase: {
    ratings: ratingsRef,
    beers: beersRef.limitToLast(3)
  },
  computed: {
    validation: function () {
      return {
        name: !!this.beerRating.name.trim()
      }
    },
    total: function () {
      return this.sliderValue / 4
    },
    isValid: function () {
      let name = this.beerRating.name
      let beer = this.beerRating.beer

      if (name.length > 2 && beer !== '') {
        return true
      }

      return false
    }
  },
  // methods
  methods: {
    addRating: function () {
      if (this.isValid) {
        this.beerRating.rating = this.total

        ratingsRef.push(this.beerRating)

        this.sliderValue = 0
        this.beerRating.beer = ''
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .container {
    padding: 20px 10px;
  }

  .range-input {
    width: 100%;
  }

  .range-wrapper {
    border-radius: 6px;
    margin-right: 10px;
    position: relative;
    padding: 12px 50px 13px 12px;
    background-color: #d9edf7;
  }

  .range-output {
    background-color: #fff;
    border-radius: 50%;
    border: 2px solid #d9edf7;
    font-weight: bold;
    height: 50px;
    line-height: 1;
    padding-top: 16px;
    position: absolute;
    right: -10px;
    text-align: center;
    top: -3px;
    width: 50px;
  }
</style>



// WEBPACK FOOTER //
// Rating.vue?fb4a5010